import { Box, Paper, Stack, Text } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { TransitGroup } from '@e-origin/shared';

import { DropdownArrow } from '@components';
import classes from './TransitType.module.css';

interface TransitTypeOption {
  value: TransitGroup;
  label: string;
  'data-pw': string;
}

interface TransitTypeProps {
  value: TransitGroup;
  onChange: (value: TransitGroup) => void;
}

const transitViewOptions: TransitTypeOption[] = [
  { value: TransitGroup.DEPARTURE, label: 'Departure', 'data-pw': 'transit-dropdown-departure' },
  { value: TransitGroup.ARRIVAL, label: 'Arrival', 'data-pw': 'transit-dropdown-arrival' },
];

export const TransitType: React.FC<TransitTypeProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState<TransitTypeOption>(transitViewOptions.find((opt) => opt.value === props.value));

  const ref = useRef(null);

  const onClickOutside = () => setIsOpen(false);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target) && !event.target.closest('#dropdown-container')) {
      onClickOutside();
    }
  };

  const transitViewSelected = (item: TransitTypeOption) => {
    if (item.value !== props.value) {
      props.onChange(item.value);
      setSelectedOption(item);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return (
    <Paper>
      <Box className={classes.container} id={'dropdown-container'} onClick={() => setIsOpen(!isOpen)}>
        <Stack gap={0}>
          <Text c={'#555454'} fz={13}>
            Transit view
          </Text>
          <Text c={'#555454'} data-pw="transit-dropdown">
            {selectedOption?.label}
          </Text>
        </Stack>
        <DropdownArrow isOpen={isOpen} />
      </Box>

      {isOpen && (
        <Paper className={classes.dropdownList} ref={ref}>
          {transitViewOptions.map((item: any) => {
            return (
              <Box
                className={classes.dropdownItem}
                key={item.value}
                onClick={() => {
                  transitViewSelected(item);
                  setIsOpen(false);
                }}
                data-pw={item['data-pw']}
              >
                <Text c={'#555454'} pl={15}>
                  {item.label}
                </Text>
              </Box>
            );
          })}
        </Paper>
      )}
    </Paper>
  );
};
